import tokens from './tokens'
import { FarmConfig } from './types'

const farms: FarmConfig[] = [
  /**
   * These 3 farms (PID 0, 1, 2) should always be at the top of the file.
   */
  {
    pid: 0,
    lpSymbol: 'GIVE',
    isSingleToken: true,
    isCommunity: true,
    swapPlatform: 'QuickSwap',
    lpAddresses: {
      4: '',
      137: '0x9Bbcda2606e616659b118399A2823E8a392f55DA',
    },
    qlpAddresses: {
      4: '',
      137: '0xe9c29faa9ba030df89dcc4efdcbf50168bae4a58',
    },
    token: tokens.give,
    quoteToken: tokens.usdc,
  },
  {
    pid: 1,
    lpSymbol: 'GIVE-USDC LP',
    swapPlatform: 'QuickSwap',
    lpAddresses: {
      4: '',
      137: '0xe9c29faa9ba030df89dcc4efdcbf50168bae4a58',
    },
    token: tokens.give,
    quoteToken: tokens.usdc,
  },
  {
    pid: 2,
    lpSymbol: 'GIVE-WMATIC LP',
    swapPlatform: 'QuickSwap',
    lpAddresses: {
      4: '',
      137: '0x71cb1552dadb57ad9cf3d5327b2de9035fa39b3f',
    },
    token: tokens.give,
    quoteToken: tokens.wmatic,
  },
  {
    pid: 3,
    lpSymbol: 'GIVE-QUICK LP',
    swapPlatform: 'QuickSwap',
    lpAddresses: {
      4: '',
      137: '0x933a80ba311C3922E37e32d876AE3f460b2bd343',
    },
    token: tokens.give,
    quoteToken: tokens.quick,
  },
  {
    pid: 4,
    lpSymbol: 'WMATIC',
    isSingleToken: true,
    swapPlatform: 'QuickSwap',
    lpAddresses: {
      4: '',
      137: '0x0d500B1d8E8eF31E21C99d1Db9A6444d3ADf1270',
    },
    qlpAddresses: {
      4: '',
      137: '0x6e7a5FAFcec6BB1e78bAE2A1F0B612012BF14827',
    },
    token: tokens.wmatic,
    quoteToken: tokens.usdc,
  },
  {
    pid: 5,
    lpSymbol: 'USDC',
    isSingleToken: true,
    swapPlatform: 'QuickSwap',
    lpAddresses: {
      4: '',
      137: '0x2791Bca1f2de4661ED88A30C99A7a9449Aa84174',
    },
    qlpAddresses: {
      4: '',
      137: '0x6e7a5FAFcec6BB1e78bAE2A1F0B612012BF14827',
    },
    token: tokens.usdc,
    quoteToken: tokens.wmatic,
  },
  {
    pid: 6,
    lpSymbol: 'DAI',
    isSingleToken: true,
    swapPlatform: 'QuickSwap',
    lpAddresses: {
      4: '',
      137: '0x8f3cf7ad23cd3cadbd9735aff958023239c6a063',
    },
    qlpAddresses: {
      4: '',
      137: '0xf04adBF75cDFc5eD26eeA4bbbb991DB002036Bdd',
    },
    token: tokens.dai,
    quoteToken: tokens.usdc,
  },
  {
    pid: 7,
    lpSymbol: 'WBTC',
    isSingleToken: true,
    swapPlatform: 'QuickSwap',
    lpAddresses: {
      4: '',
      137: '0x1bfd67037b42cf73acf2047067bd4f2c47d9bfd6',
    },
    qlpAddresses: {
      4: '',
      137: '0xF6a637525402643B0654a54bEAd2Cb9A83C8B498',
    },
    token: tokens.wbtc,
    quoteToken: tokens.usdc,
  },
  {
    pid: 8,
    lpSymbol: 'WETH',
    isSingleToken: true,
    swapPlatform: 'QuickSwap',
    lpAddresses: {
      4: '',
      137: '0x7ceb23fd6bc0add59e62ac25578270cff1b9f619',
    },
    qlpAddresses: {
      4: '',
      137: '0x853Ee4b2A13f8a742d64C8F088bE7bA2131f670d',
    },
    token: tokens.weth,
    quoteToken: tokens.usdc,
  },
  {
    pid: 9,
    lpSymbol: 'QUICK',
    isSingleToken: true,
    swapPlatform: 'QuickSwap',
    lpAddresses: {
      4: '',
      137: '0x831753dd7087cac61ab5644b308642cc1c33dc13',
    },
    qlpAddresses: {
      4: '',
      137: '0x1F1E4c845183EF6d50E9609F16f6f9cAE43BC9Cb',
    },
    token: tokens.quick,
    quoteToken: tokens.usdc,
  },
  {
    pid: 10,
    lpSymbol: 'CRV',
    isSingleToken: true,
    swapPlatform: 'QuickSwap',
    lpAddresses: {
      4: '',
      137: '0x172370d5cd63279efa6d502dab29171933a610af',
    },
    qlpAddresses: {
      4: '',
      137: '0x8982D71337003cd172198739238adA0D5d0BD2Fe',
    },
    token: tokens.crv,
    quoteToken: tokens.usdc,
  },
  {
    pid: 11,
    lpSymbol: 'AAVE',
    isSingleToken: true,
    swapPlatform: 'QuickSwap',
    lpAddresses: {
      4: '',
      137: '0xd6df932a45c0f255f85145f286ea0b292b21c90b',
    },
    qlpAddresses: {
      4: '',
      137: '0x7c76B6B3FE14831A39C0fec908DA5f17180df677',
    },
    token: tokens.aave,
    quoteToken: tokens.usdc,
  },
  {
    pid: 12,
    lpSymbol: 'USDC-MATIC LP',
    swapPlatform: 'QuickSwap',
    isHiddenFarm: true,
    lpAddresses: {
      4: '',
      137: '0x6e7a5fafcec6bb1e78bae2a1f0b612012bf14827',
    },
    token: tokens.usdc,
    quoteToken: tokens.wmatic,
  },
  {
    pid: 13,
    lpSymbol: 'GIVE-USDC SLP',
    swapPlatform: 'SushiSwap',
    lpAddresses: {
      4: '',
      137: '0xF87772a82B918b8A90Fb16B1bc1199A85ab17a6A',
    },
    token: tokens.give,
    quoteToken: tokens.usdc,
  },
  {
    pid: 14,
    lpSymbol: 'GIVE-USDC ALP',
    swapPlatform: 'ApeSwap',
    lpAddresses: {
      4: '',
      137: '0x75D63764295bfE088CE1685E971faA39Bbc8cDa1',
    },
    token: tokens.give,
    quoteToken: tokens.usdc,
  },
  {
    pid: 15,
    lpSymbol: 'SUSHI',
    isSingleToken: true,
    swapPlatform: 'SushiSwap',
    lpAddresses: {
      4: '',
      137: '0x0b3F868E0BE5597D5DB7fEB59E1CADBb0fdDa50a',
    },
    qlpAddresses: {
      4: '',
      137: '0xE15E9d2a5af5c1d3524bBC594DDc4a7D80aD27CD',
    },
    token: tokens.sushi,
    quoteToken: tokens.usdc,
  },
  {
    pid: 16,
    lpSymbol: 'BANANA',
    isSingleToken: true,
    swapPlatform: 'ApeSwap',
    lpAddresses: {
      4: '',
      137: '0x5d47bAbA0d66083C52009271faF3F50DCc01023C',
    },
    qlpAddresses: {
      4: '',
      137: '0xd7b3132b9aedc86e6cd28ba3b29da6c30c049327',
    },
    token: tokens.banana,
    quoteToken: tokens.usdc,
  },
  {
    pid: 17,
    lpSymbol: 'SPADE',
    isSingleToken: true,
    swapPlatform: 'SushiSwap',
    lpAddresses: {
      4: '',
      137: '0xf5EA626334037a2cf0155D49eA6462fDdC6Eff19',
    },
    qlpAddresses: {
      4: '',
      137: '0xc271d4E35744a8d0249b06336634EB715f9617ff',
    },
    token: tokens.spade,
    quoteToken: tokens.usdc,
  },
  {
    pid: 18,
    lpSymbol: 'PolyDoge',
    isSingleToken: true,
    swapPlatform: 'QuickSwap',
    lpAddresses: {
      4: '',
      137: '0x8A953CfE442c5E8855cc6c61b1293FA648BAE472',
    },
    qlpAddresses: {
      4: '',
      137: '0x7b3E67E63906d8576466c2f48158A30be0a9e36c',
    },
    token: tokens.polydoge,
    quoteToken: tokens.usdc,
  },
  {
    pid: 19,
    lpSymbol: 'GIVE-PolyDoge QLP',
    swapPlatform: 'QuickSwap',
    lpAddresses: {
      4: '',
      137: '0x5bCEdab39b7d3231666193c6e59a6ef725F7EDF9',
    },
    token: tokens.give,
    quoteToken: tokens.polydoge,
  },
  {
    pid: 20,
    lpSymbol: 'GIVE-PolyDoge SLP',
    swapPlatform: 'SushiSwap',
    lpAddresses: {
      4: '',
      137: '0x83628d58C8f704f7a56c7fC51B9A1f27f5533ce9',
    },
    token: tokens.give,
    quoteToken: tokens.polydoge,
  },
  {
    pid: 21,
    lpSymbol: 'GIVE-PolyDoge ALP',
    swapPlatform: 'ApeSwap',
    lpAddresses: {
      4: '',
      137: '0xf40dF706a38f41911305265A7cBBf586A2848eA6',
    },
    token: tokens.give,
    quoteToken: tokens.polydoge,
  },
  {
    pid: 22,
    lpSymbol: 'GIVE-SPADE SLP',
    swapPlatform: 'SushiSwap',
    lpAddresses: {
      4: '',
      137: '0x592db49db5e7a74905e7e1e91cb58beaa24e145f',
    },
    token: tokens.give,
    quoteToken: tokens.spade,
  },
  {
    pid: 23,
    lpSymbol: 'GIVE-WETH QLP',
    swapPlatform: 'QuickSwap',
    lpAddresses: {
      4: '',
      137: '0xD57D886D775d8fF7C2376d80986B2e2BfDAe5D19',
    },
    token: tokens.give,
    quoteToken: tokens.weth,
  },
  {
    pid: 24,
    lpSymbol: 'GIVE-WETH SLP',
    swapPlatform: 'SushiSwap',
    lpAddresses: {
      4: '',
      137: '0xadcb6f2d67fFce93738b3332d4F2599F937A01fd',
    },
    token: tokens.give,
    quoteToken: tokens.weth,
  },
  {
    pid: 25,
    lpSymbol: 'GIVE-WETH ALP',
    swapPlatform: 'ApeSwap',
    lpAddresses: {
      4: '',
      137: '0xf29dB6B1d1a8710D6F93C1B93d458c1E2c2E3902',
    },
    token: tokens.give,
    quoteToken: tokens.weth,
  },
  {
    pid: 26,
    lpSymbol: 'GIVE-WBTC QLP',
    swapPlatform: 'QuickSwap',
    lpAddresses: {
      4: '',
      137: '0x13c1E36Cf4f1745888Fe4F59C47eb8a94Aa306F3',
    },
    token: tokens.give,
    quoteToken: tokens.wbtc,
  },
  {
    pid: 27,
    lpSymbol: 'GIVE-WBTC SLP',
    swapPlatform: 'SushiSwap',
    lpAddresses: {
      4: '',
      137: '0xE38173F723ef1522AcB494e6C68b16E52cd8248a',
    },
    token: tokens.give,
    quoteToken: tokens.wbtc,
  },
  {
    pid: 28,
    lpSymbol: 'GIVE-WBTC ALP',
    swapPlatform: 'ApeSwap',
    lpAddresses: {
      4: '',
      137: '0x983F297473Ce88D450A4dF059E434404De876443',
    },
    token: tokens.give,
    quoteToken: tokens.wbtc,
  },
  {
    pid: 29,
    lpSymbol: 'GIVE-WMATIC SLP',
    swapPlatform: 'SushiSwap',
    lpAddresses: {
      4: '',
      137: '0xff383ae9f3c3D3C4f8B4cA1160ACB7D0aFBd2a34',
    },
    token: tokens.give,
    quoteToken: tokens.wmatic,
  },
  {
    pid: 30,
    lpSymbol: 'GIVE-SUSHI SLP',
    swapPlatform: 'SushiSwap',
    lpAddresses: {
      4: '',
      137: '0x3F334291E218f8de7e8C9d1F6d392E3A28B2ebd7',
    },
    token: tokens.give,
    quoteToken: tokens.sushi,
  },
  {
    pid: 31,
    lpSymbol: 'GIVE-COVAL QLP',
    swapPlatform: 'QuickSwap',
    lpAddresses: {
      4: '',
      137: '0x8dbB0086aafF2C662bcDb06087e17B2123Ba5030',
    },
    token: tokens.give,
    quoteToken: tokens.coval,
  },
  {
    pid: 32,
    lpSymbol: 'GIVE-WMATIC ALP',
    swapPlatform: 'ApeSwap',
    lpAddresses: {
      4: '',
      137: '0x652016fc41e4fD0d518957f093dA64873aAA8859',
    },
    token: tokens.give,
    quoteToken: tokens.wmatic,
  },
  {
    pid: 33,
    lpSymbol: 'GIVE-BANANA ALP',
    swapPlatform: 'ApeSwap',
    lpAddresses: {
      4: '',
      137: '0xd4E69D731772303176923022E33aEddd08779CBE',
    },
    token: tokens.give,
    quoteToken: tokens.banana,
  },
  {
    pid: 34,
    lpSymbol: 'COVAL',
    isSingleToken: true,
    swapPlatform: 'QuickSwap',
    lpAddresses: {
      4: '',
      137: '0x4597c8A59Ab28B36840B82B3A674994A279593D0',
    },
    qlpAddresses: {
      4: '',
      137: '0xFE53C6682A1536896E0e15db48fD83a49ECDb979',
    },
    token: tokens.coval,
    quoteToken: tokens.usdc,
  },
  {
    pid: 35,
    lpSymbol: 'PolyDoge-WMATIC QLP',
    hasFee: true,
    swapPlatform: 'QuickSwap',
    lpAddresses: {
      4: '',
      137: '0x264e6BC3f95633725658e4D9640f7F7D9100F6AC',
    },
    token: tokens.polydoge,
    quoteToken: tokens.wmatic,
  },
  {
    pid: 36,
    lpSymbol: 'PolyDoge-WETH QLP',
    hasFee: true,
    swapPlatform: 'QuickSwap',
    lpAddresses: {
      4: '',
      137: '0xE5C1B80AD67ccdfe387c57A136Bc92eDb8F73807',
    },
    token: tokens.polydoge,
    quoteToken: tokens.weth,
  },
  {
    pid: 37,
    lpSymbol: 'EMON',
    isSingleToken: true,
    swapPlatform: 'QuickSwap',
    lpAddresses: {
      4: '',
      137: '0xd6A5aB46ead26f49b03bBB1F9EB1Ad5c1767974a',
    },
    qlpAddresses: {
      4: '',
      137: '0xd6BEab00d778322D00b957dbA780D31C50F8027B',
    },
    token: tokens.emon,
    quoteToken: tokens.usdc,
  },
  {
    pid: 38,
    lpSymbol: 'LINK',
    isSingleToken: true,
    swapPlatform: 'QuickSwap',
    lpAddresses: {
      4: '',
      137: '0x53E0bca35eC356BD5ddDFebbD1Fc0fD03FaBad39',
    },
    qlpAddresses: {
      4: '',
      137: '0x70ceE55c98F6DA2685807611f115eA737d4a248E',
    },
    token: tokens.link,
    quoteToken: tokens.usdc,
  },
  {
    pid: 39,
    lpSymbol: 'GIVE-DFYN DLP',
    swapPlatform: 'DFYN',
    lpAddresses: {
      4: '',
      137: '0x9ADe3b798eC2432EEF1D728b218FeACEd52f2E56',
    },
    token: tokens.give,
    quoteToken: tokens.dfyn,
  },
  {
    pid: 40,
    lpSymbol: 'GIVE-ROUTE DLP',
    swapPlatform: 'DFYN',
    lpAddresses: {
      4: '',
      137: '0xA10D5D984C2d4Dd34C58F0848A964f20609ce01f',
    },
    token: tokens.give,
    quoteToken: tokens.route,
  },
  {
    pid: 41,
    lpSymbol: 'GIVE-WMATIC DLP',
    swapPlatform: 'DFYN',
    lpAddresses: {
      4: '',
      137: '0x9b9d5747b212568225759a07Bd55f39e0Aa74248',
    },
    token: tokens.give,
    quoteToken: tokens.wmatic,
  },
  {
    pid: 42,
    lpSymbol: 'DFYN',
    isSingleToken: true,
    swapPlatform: 'DFYN',
    lpAddresses: {
      4: '',
      137: '0xC168E40227E4ebD8C1caE80F7a55a4F0e6D66C97',
    },
    qlpAddresses: {
      4: '',
      137: '0x4c38938E21cB9796932B0B0Cc3f8a088f07b49B0',
    },
    token: tokens.dfyn,
    quoteToken: tokens.usdc,
  },
  {
    pid: 43,
    lpSymbol: 'ROUTE',
    isSingleToken: true,
    swapPlatform: 'DFYN',
    lpAddresses: {
      4: '',
      137: '0x16ECCfDbb4eE1A85A33f3A9B21175Cd7Ae753dB4',
    },
    qlpAddresses: {
      4: '',
      137: '0x40F0A05C8c7a86aD1491A3911c293e093fe92436',
    },
    token: tokens.route,
    quoteToken: tokens.usdc,
  },
  {
    pid: 44,
    lpSymbol: 'EMON-WMATIC QLP',
    hasFee: true,
    swapPlatform: 'QuickSwap',
    lpAddresses: {
      4: '',
      137: '0xa408a751B6D05d1649c5bbD7C38842fb17ea1846',
    },
    token: tokens.emon,
    quoteToken: tokens.wmatic,
  },
  {
    pid: 45,
    lpSymbol: 'GIVE-ELK ELP',
    hasFee: false,
    swapPlatform: 'ElkSwap',
    lpAddresses: {
      4: '',
      137: '0x1cb5aE99e055869DBaB66B38110eA95ef8e6ffb4',
    },
    token: tokens.give,
    quoteToken: tokens.elk,
  },
  {
    pid: 46,
    lpSymbol: 'ELK',
    isSingleToken: true,
    swapPlatform: 'ElkSwap',
    lpAddresses: {
      4: '',
      137: '0xE1C110E1B1b4A1deD0cAf3E42BfBdbB7b5d7cE1C',
    },
    qlpAddresses: {
      4: '',
      137: '0x7e95f968489382E695B2DA320ca005B8D617b459',
    },
    token: tokens.elk,
    quoteToken: tokens.usdc,
  },
]

export default farms
